export default __webpack_public_path__ + "static/media/TRAINING COGNITIVO_ICONA.6934f2b4.svg";